import React, { useEffect, useState } from 'react';
import './Report.css';
import ReportGrid from '../components/Reports/ReportGrid';
import ReportModal from '../components/Reports/ReportModal';
import Loader from '../utils/Loader';
import { loadReports } from '../services/api';

function Report() {
  const [reports, setReports] = useState([]);
  const [selectedReport, setSelectedReport] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    const fetchReports = async () => {
      try {
        const data = await loadReports();
        setReports(data);
        // Don't auto-select anymore since we're using modal
      } catch (err) {
        setError(err.detail || 'Failed to load reports');
      } finally {
        setLoading(false);
      }
    };

    fetchReports();
  }, []);

  const handleReportSelect = (report) => {
    setSelectedReport(report);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedReport(null);
  };

  if (loading) {
    return (
      <div className="report loading">
        <Loader size="large" text="Loading reports..." />
      </div>
    );
  }

  if (error) {
    return <div className="report error">{error}</div>;
  }

  return (
    <div className="report">
      <ReportGrid
        reports={reports}
        onSelectReport={handleReportSelect}
        selectedReport={selectedReport}
      />
      
      <ReportModal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        report={selectedReport}
        reportType="on_schedule"
      />
    </div>
  );
}

export default Report;
